import SideMenu from '@/containers/side-menu/SideMenu.vue'
const UsageDensity = () => import('@/pages/usage-density/UsageDensity')

export default {
  path: '/usage-density',
  name: 'UsageDensity',
  components: {
    mainContent: UsageDensity,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'usage-density'
    },
    breadcrumb: {
      title: 'Mapa de densidade da ocupação dos estacionamentos',
      paths: [
        { title: 'mapas' },
        { title: 'estacionamento' },
      ]
    }
  }
}